import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=36e23a68&scoped=true&"
import script from "./ShoppingCart.vue?vue&type=script&lang=js&"
export * from "./ShoppingCart.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCart.vue?vue&type=style&index=0&id=36e23a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../checkout/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e23a68",
  null
  
)

export default component.exports